import { Navigate } from "react-router-dom";
import Header from "../Components/ServicePortal/CommonComponent/Header";
import LeftSideBar from "../Components/ServicePortal/CommonComponent/LeftSideBar";
import { getRole, getToken } from "../Utils/types";

const PrivateServiceRoute = ({ Component }) => {
  const auth = getToken();
  return auth && getRole() === "ServiceProvider" ? (
    <>
      <Header />
      <div className="main-section">
        <LeftSideBar />
        <Component />
      </div>
   </>
  ) : (
    <Navigate to="/" />
  );
};

export default PrivateServiceRoute;
